import CardHeader from '@/pages/components/CardHeader.vue';
import { Empty } from 'zhs-components';
export default {
  components: {
    CardHeader,
    Empty
  },
  props: {
    menu: {}
  },

  data() {
    return {
      trainList: []
    };
  },

  methods: {
    jumpTo(menu, item) {
      window.location.href = `/trainDetails.html?termId=${item.term_id}&trainingId=${item.training_id}&menuId=${menu.menu_id}&name=${menu.module_name}`;
    },

    async getHomeTrainInfo() {
      await this.$http.getHomeTrainInfo({
        menu_id: this.$props.menu.menu_id,
        num: this.$props.menu.num
      }).then(res => {
        if (!res) console.error('no data');
        this.trainList = res;
      });
    }

  },

  mounted() {
    this.getHomeTrainInfo();
  }

};